import React, { useEffect } from 'react';
import { actions } from './reducers';
import setup from './setup';

const { healthAPI } = setup;


type Dispatch = React.Dispatch<{ type: string, payload: boolean }>

export function useCheckBackendHealth(dispatchOnLine: Dispatch) {
  // check if backend is alive
  useEffect(() => {
    const check = () => {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 2000); // 2 секунды таймаут
      
      fetch(healthAPI, { signal: controller.signal })
        .then((res) => dispatchOnLine(actions.setup(res.ok)))
        .catch(() => dispatchOnLine(actions.setup(false)))
        .finally(() => clearTimeout(timeoutId));
    };
    
    check();
    const id = setInterval(check, 10000);
    return () => clearInterval(id);
  }, [dispatchOnLine]);
}

